import React, { useEffect, useState } from "react";
import NavigationComponent from "../../../components/NavigationComponent";
import Header from "../../../components/Header";
import { getMasterSubMenu, getSectionCMS } from "../../../adminApi/mastermenu";
import { toast } from "react-toastify";
import axios from "axios";
import { useParams } from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";
import ColorDropdowns from "../../../components/ColorDropdown/ColorDropdowns";
import { updateHeaderTitleFunc } from "../../../adminApi/updateHeaderTitle";
const CmsHome = () => {
  const [headerTitle, setHeaderTitle] = useState();
  const [headerTitleColor, setHeaderTitleColor] = useState();
  const [sectionData, setSectionData] = useState([]);
  const [formData, setFormData] = useState({});
  const [homeDescription, setHomeDescription] = useState();
  const [images, setImages] = useState([]);
  const [selectedHeaderFile, setSelectedHeaderFile] = useState();
  const [selectedDescImage, setSelectedDescImage] = useState();
  const [showHeaderLoader, setShowHeaderLoader] = useState(false);
  const [homeDesc, setHomeDesc] = useState();
  useEffect(() => {
    getMasterSubMenuData();
  }, [images]);
  const token = localStorage.getItem("access_token");

  const getMasterSubMenuData = async () => {
    setShowHeaderLoader(true);
    const section = await getSectionCMS(token, 172);
    setSectionData(section);
    setShowHeaderLoader(false);
    setHomeDescription(section?.[1]?.descriptionSection?.description);
    section?.map((item) => {
      if (item?.section_name === "Home Description") {
        setHomeDesc(item?.descriptionSection?.description);
      }
    });
  };

  // setMenuId(idMenu)
  const handleFileChange = async (e, id) => {
    const sectionId = parseInt(id, 10);
    e.preventDefault();

    if (
      e.target.value?.split(".")?.[1]?.toLowerCase() === "jpg" ||
      e.target.value?.split(".")?.[1]?.toLowerCase() === "jpeg" ||
      e.target.value?.split(".")?.[1]?.toLowerCase() === "png"
    ) {
      try {
        const selectedFiles = e.target.files;

        if (selectedFiles && selectedFiles?.length > 0) {
          const file = selectedFiles[0];
          setSelectedDescImage(file?.name);
          const reader = new FileReader();

          // Create a Promise to wait for the FileReader to load
          const loadPromise = new Promise((resolve) => {
            reader.onloadend = () => {
              resolve();
            };
          });

          // Start loading the file
          reader.readAsDataURL(file);

          // Wait for the FileReader to finish loading
          await loadPromise;

          const img = new Image();
          img.src = reader.result;

          img.onload = async () => {
            // Set the desired height and width
            const desiredHeight = 412;
            const desiredWidth = 550;
  
            // Create a canvas element to draw the image with the new dimensions
            const canvas = document.createElement("canvas");
            canvas.height = desiredHeight;
            canvas.width = desiredWidth;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            // Convert the canvas content to a data URL
            const resizedImage = canvas.toDataURL("image/jpeg"); // You can also use 'image/png' for PNG format

            const postData = {
              image: resizedImage,
              section_id: sectionId,
            };

            //Perform the API call here
            const token = localStorage.getItem("access_token");
            try {
              const response = await axios.post(
                process.env.REACT_APP_BASE_URL + `/admin/imageupload-cms`,
                postData,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                  },
                }
              );
              if (response?.status === 200 || response?.status === 201) {
                toast.success("Image uploaded successfully.");
                setSelectedHeaderFile();
                await getMasterSubMenuData();
              }
            } catch (error) {
              return error;
            }
          };
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      toast.error(
        `Invalid format of image, image should only be JPEG,PNG and JPG`
      );
      return;
    }
  };

  const handleFileChange2 = async (e, id) => {
    const sectionId = parseInt(id, 10);
    e.preventDefault();
    if (
      e.target.value?.split(".")?.[1]?.toLowerCase() === "jpg" ||
      e.target.value?.split(".")?.[1]?.toLowerCase() === "jpeg" ||
      e.target.value?.split(".")?.[1]?.toLowerCase() === "png"
    ) {
      try {
        const selectedFiles = e.target.files;
        if (selectedFiles && selectedFiles?.length > 0) {
          const file = selectedFiles[0];
          setSelectedHeaderFile(file?.name);
          const reader = new FileReader();

          // Create a Promise to wait for the FileReader to load
          const loadPromise = new Promise((resolve) => {
            reader.onloadend = () => {
              resolve();
            };
          });

          // Start loading the file
          reader.readAsDataURL(file);

          // Wait for the FileReader to finish loading
          await loadPromise;

          const img = new Image();
          img.src = reader.result;

          img.onload = async () => {
            // Set the desired height and width
            const desiredHeight = 780;
            const desiredWidth = 1920;

            // Create a canvas element to draw the image with the new dimensions
            const canvas = document.createElement("canvas");
            canvas.height = desiredHeight;
            canvas.width = desiredWidth;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            // Convert the canvas content to a data URL
            const convertedFile = {
              image: canvas.toDataURL("image/jpeg"), // Use 'image/jpeg' for JPEG format
            };

            const convertedFileName = {
              name: file.name,
            };

            setImages([convertedFile]);
            setFormData({ ...formData, file: convertedFileName });

            const postData = {
              image: convertedFile.image,
              section_id: sectionId,
            };

            // Perform the API call here
            const token = localStorage.getItem("access_token");
            try {
              const response = await axios.post(
                process.env.REACT_APP_BASE_URL + `/admin/imageupload-cms`,
                postData,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                  },
                }
              );

              if (response?.status === 200) {
                toast.success("Image uploaded successfully.");
                setSelectedHeaderFile();
                await getMasterSubMenuData();
              }
            } catch (error) {
              return error;
            }
          };
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      toast.error(
        `Invalid format of image, image should only be JPEG,PNG and JPG`
      );
      return;
    }
  };

  const descriptionHandler = async () => {
    try {
      // if (homeDescription?.length < 150) {
      //   toast.error("Description must be atleast 150 characters.");
      //   return;
      // }
      // if (homeDescription?.length > 350) {
      //   toast.error("Description must not be more than 350 characters.");
      //   return;
      // }
      const postData = {
        description: homeDescription,
        section_id: sectionData[1]?.id,
      };
      //integrating the description API for home
      const token = localStorage.getItem("access_token");
      const response = await axios.post(
        process.env.REACT_APP_BASE_URL + `/admin/description-cms`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.status == 201 || response?.status == 200) {
        toast.success("What's description added successfully.");
      }
    } catch (error) {
      toast.error("Please add description");
      console.error("error", error);
    }
  };

  const cahngeHeaderTitleHandler = async (headerTitleSectionId) => {
    if (headerTitle?.trim()?.length < 1) {
      toast.error("Title can't contain spaces.");
      return;
    }
    if (headerTitle === undefined || headerTitle === null) {
      toast.error(`header title is a required field.`);
      return;
    }
    const updateHeaderTitle = await updateHeaderTitleFunc(
      headerTitleSectionId,
      headerTitleColor,
      headerTitle,
      token
    );
    if (
      updateHeaderTitle?.status === 200 ||
      updateHeaderTitle?.status === 201
    ) {
      toast.success(`Header title updated successfully.`);
    }
  };
  const dummyDescriptionHandler = async (descId) => {
    try {
      const postData = {
        description: homeDesc,
        section_id: descId,
      };
      const token = localStorage.getItem("access_token");
      const response = await axios.post(
        process.env.REACT_APP_BASE_URL + `/admin/description-cms`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.status == 201 || response?.status == 200) {
        toast.success("Home description added successfully.");
      }
    } catch (error) {
      toast.error(error);
    }
  };
  return (
    <>
      <div className="container--component">
        <div className="container--grid">
          <NavigationComponent />
          <div className="Adminpage">
            <Header title="Home" subTitle="(Manage Home)" />
            <div class="accordion__card__body" style={{ display: "block" }}>
              <h3 class="title">
                Note: Compress back after completion of activity
              </h3>
              <div class="commonList">
                <div class="commonList__row">
                  {sectionData?.map(
                    (item) =>
                      item?.section_name === "Header" && (
                        <div class="commonList__row__col" key={item?.id}>
                          <h4 class="label">
                            {sectionData?.length > 0
                              ? item?.section_name
                              : "Header"}{" "}
                            Image:
                          </h4>
                          <div class="cardbox">
                            <div class="browseBox">
                              <div class="browseFile">
                                <div class="browseFile__icon">
                                  <svg
                                    width="33"
                                    height="33"
                                    viewBox="0 0 33 33"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                  >
                                    <rect
                                      x="0.180664"
                                      width="32.53"
                                      height="32.53"
                                      fill="url(#pattern0)"
                                    />
                                    <defs>
                                      <pattern
                                        id="pattern0"
                                        patternContentUnits="objectBoundingBox"
                                        width="1"
                                        height="1"
                                      >
                                        <image xlinkHref="data:image/png;base64,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" />
                                      </pattern>
                                    </defs>
                                  </svg>
                                </div>
                                <h4 class="browseFile__text">
                                  Drag files to upload
                                </h4>
                                <p class="browseFile__ortext">or</p>
                                <input
                                  class="hiddenInput"
                                  id="BrowseFiles"
                                  type="file"
                                  onChange={(e) =>
                                    handleFileChange2(e, item?.id)
                                  }
                                />
                                <h6>{selectedHeaderFile}</h6>
                                <label for="BrowseFiles" class="browseBtn">
                                  Browse Files
                                </label>
                                <div class="browseFileData">
                                  <p class="browseFileData__text">
                                    Max File Size: <strong>10 MB</strong>
                                  </p>
                                  <p class="browseFileData__text">
                                    Supported file type:{" "}
                                    <strong>JPG,PNG,SVG</strong>
                                  </p>
                                </div>
                                <div>
                                  {showHeaderLoader === true ? (
                                    <div className="loader_container">
                                      <FadeLoader
                                        color="#5497C7"
                                        height={21}
                                        margin={1}
                                      />
                                    </div>
                                  ) : (
                                    <img
                                      src={item?.imageSection?.image}
                                      alt=""
                                      className="prevImage"
                                    />
                                  )}
                                </div>
                              </div>
                              <div class="adminbutton__group">
                                {/* <button class="adminbtn adminbtn-blueOutline">
                              Cancel
                            </button> */}
                                {/* <button class="adminbtn adminbtn-primary">
                                  Save
                                </button> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                  )}

                  {sectionData?.map(
                    (item) =>
                      item?.section_name === "What's New" && (
                        <div class="commonList__row__col">
                          <h4 class="label">{item?.section_name} Image:</h4>
                          <div class="cardbox">
                            <div class="browseBox">
                              <div class="browseFile">
                                <div class="browseFile__icon">
                                  <svg
                                    width="33"
                                    height="33"
                                    viewBox="0 0 33 33"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                  >
                                    <rect
                                      x="0.180664"
                                      width="32.53"
                                      height="32.53"
                                      fill="url(#pattern0)"
                                    />
                                    <defs>
                                      <pattern
                                        id="pattern0"
                                        patternContentUnits="objectBoundingBox"
                                        width="1"
                                        height="1"
                                      >
                                        <use
                                          xlinkHref="#image0_0_11529"
                                          transform="scale(0.01)"
                                        />
                                      </pattern>
                                      <image
                                        id="image0_0_11529"
                                        width="100"
                                        height="100"
                                        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFoElEQVR4nO2dW2icRRTHJznzbeodL4hWK4IXtIoggiJU8aWKt1YfRH0RtFIFCZj9zmyCFtcbYlHEB6soiPogVKEP6oOXChUsqBiotPuds4kNLakQhQYvrWhbzCfzZROyzaa7m73MfN+eH5y30J5z/jPzzeXMrFKCIAiCIAiCIAiCIAiCIHSOwviFgHRrv6EHteHHtaHhig0FBX4YCrQ2l6fL1X0xiAwdIAjpam14kza8XSMf1IbjBu0wIH0LyC/p4fIaEagVsHQeIL0AyD83IcCJDflXQHo1F5ZWt621ZJ1cWFoNSO9qQ/+2TYhFRjPa0Kc6jG5wHa+/hD+dAsgva+RjnROiZq/5TA3zxa7D94p+E92vDU91VYhqUQ4FhjcqFfepnqZYygHyFmdCmOOFoU/U8MQZqicxvBKQv3Mugqk2MMQ5E12meor8nlVtnT2Zdhv9FmD5GtUTDJcuAqQJ90nnOsMXHwwK0VUq0wyVzgJDe50n2zRsk3ZXQGWSYtyvDX3uQZLjZgwMj6rB8QGVNcDQi66Tq5crCvIWlU7iPvsxDMJoAxh6E5C/ASTShqddJ1W3KkqB1qq0oMPoZjD8hh1zXSdOd6yX0IQqjp6svGXjaJBsdRve5TpZunv2lPIRMNE9YHjMgwTFXbbf7UxReYPhlRrpCw8SEzsz5KeVDwCW1zd5OJRRo1/scO1UjMrx6Iz7ZLAXZhunIyniPjt9dZ0A7Z3Rh07kAKTX3QfPPtphQH4bDD+vkR/ThbHrVXHfio6KYT9eHgQep8aQj2jkrzTSEypfPqetYkBYvl0j/ec8SJNSQ/rH1gXk8uUrWlcjv2eVzKa4Xb3mmP0Gt9Rj7KF/CoN+TyO/3/UCicZtCkK6s2kxAOnelIlxBAyvm/ff8LpkLHftV02jGVuw13ghRXGHTsVJnqktRjpESYT5qKGFZT/SQ6kSA5denCWTko4W2rXs/zbbAeosADlKc89IW09JPvZLoZFuTI0Y2Pi2he89JTD8SG3HZw+XMiVGKkRB/nsAxy9R1cR9Tss42zhMpXT4+rLK2Vxh7ErvxcDWd1d97ilgojvmHZ29gZRtMXwXJSk1mlufgOF3sjhMpW/4im5KHNTIX3spGnbuEMjHnmI3IystxrPSTuxMz/C+pyD9lazgNdIfXomB3Tse9a6n2Iupdi7s3JGKBWG0QXWZwNCjruNeYJvsLOuoB44kNrB4kdRx7OUc13HPG/JWW1Hyp3NHKgaGN3f3nl9SxPGKR/HvUoA87tqR6lZCB+y8/ESmDX1cL9X2b+r+O0gHnMdbbVN2lrXTA0eaa0nIpXqC2L9x7WfzjZEP2W/IB84dEUHiSg6O2q495DrBIgjP5WBa2SW76wSLIDyXg/3JWbots3ed5GYMsvoNMbRjdkaCvNW9MyLI/F1GMHSX6ySLIBzbQpMFV5Z5v+tE6x4fsqruxGvDoWuHdA8LAkg/VEdQ3LfCw5Vr3CuC2JPbRUHYshQPHIt7UJBpNTh+eo0wkgqU7R44GPeWIPTMkoHYLXCvDq1M5gWZVIZPqxNMeb3PlzwhQ4I0fEJaeSfXucM6w4IA0lsNibEgqNdcO60zKggY/n4ZF0WTqvhnXTuvMyaIPRRU4d5z1XLRyIM+XReDFAsCSLvVk3T+ssWYF2W4vMY+K+E6IJ1uQbarkd1nqrYxQmcnFywdz8AgbYLYi6nIz3XsxwAg5Fvs3osIwvUbj+HRIB9d2xEhaghzt33GT3oI1xCCuD+kB+xOuuo29n1bW9/UrTph8HXIslWgyNugwLd58468/bkJ+7C9/dYA0o+deBUC/BFkKnno0/BmO1r4/SbjQoqlU+1Uz+6TBSFf16rlGvhBlqRhtOH/Ot4GRkqXqqGxC9TQ5EndSZ4gCIIgCIIgCIIgCIIgCIIgCIIgCIIgCJb/AX4RWhfolytoAAAAAElFTkSuQmCC"
                                      />
                                    </defs>
                                  </svg>
                                </div>
                                <h4 class="browseFile__text">
                                  Drag files to upload
                                </h4>
                                <p class="browseFile__ortext">or</p>
                                <input
                                  class="hiddenInput"
                                  id="BrowseFiles2"
                                  type="file"
                                  onChange={(e) =>
                                    handleFileChange(e, item?.id)
                                  }
                                />

                                <label for="BrowseFiles2" class="browseBtn">
                                  Browse Files
                                </label>
                                <h6>{selectedDescImage}</h6>
                                <div class="browseFileData">
                                  <p class="browseFileData__text">
                                    Max File Size: <strong>10 MB</strong>
                                  </p>
                                  <p class="browseFileData__text">
                                    Supported file type:{" "}
                                    <strong>JPG,PNG,SVG</strong>
                                  </p>
                                </div>
                                <div>
                                  {showHeaderLoader === true ? (
                                    <div className="loader_container">
                                      <FadeLoader
                                        color="#5497C7"
                                        height={21}
                                        margin={1}
                                      />
                                    </div>
                                  ) : (
                                    <img
                                      src={item?.imageSection?.image}
                                      alt=""
                                      className="prevImage"
                                    />
                                  )}
                                </div>
                              </div>
                              <div class="adminbutton__group">
                                {/* <button class="adminbtn adminbtn-blueOutline">
                          Cancel
                        </button> */}
                                {/* <button class="adminbtn adminbtn-primary">
                                  Save
                                </button> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                  )}

                  {sectionData?.map(
                    (items) =>
                      items?.section_name === "Header Title" && (
                        <div class="commonList__row__col">
                          <h4 class="label">Header Title</h4>
                          <div class="cardbox">
                            <div class="browseBox">
                              <div class="browseFile_color_list">
                                <div class="browseFile__icon">
                                  <svg
                                    width="33"
                                    height="33"
                                    viewBox="0 0 33 33"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                  >
                                    <rect
                                      x="0.180664"
                                      width="32.53"
                                      height="32.53"
                                      fill="url(#pattern0)"
                                    />
                                    <defs>
                                      <pattern
                                        id="pattern0"
                                        patternContentUnits="objectBoundingBox"
                                        width="1"
                                        height="1"
                                      >
                                        <use
                                          xlinkHref="#image0_0_11529"
                                          transform="scale(0.01)"
                                        />
                                      </pattern>
                                      <image
                                        id="image0_0_11529"
                                        width="100"
                                        height="100"
                                        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFoElEQVR4nO2dW2icRRTHJznzbeodL4hWK4IXtIoggiJU8aWKt1YfRH0RtFIFCZj9zmyCFtcbYlHEB6soiPogVKEP6oOXChUsqBiotPuds4kNLakQhQYvrWhbzCfzZROyzaa7m73MfN+eH5y30J5z/jPzzeXMrFKCIAiCIAiCIAiCIAiCIHSOwviFgHRrv6EHteHHtaHhig0FBX4YCrQ2l6fL1X0xiAwdIAjpam14kza8XSMf1IbjBu0wIH0LyC/p4fIaEagVsHQeIL0AyD83IcCJDflXQHo1F5ZWt621ZJ1cWFoNSO9qQ/+2TYhFRjPa0Kc6jG5wHa+/hD+dAsgva+RjnROiZq/5TA3zxa7D94p+E92vDU91VYhqUQ4FhjcqFfepnqZYygHyFmdCmOOFoU/U8MQZqicxvBKQv3Mugqk2MMQ5E12meor8nlVtnT2Zdhv9FmD5GtUTDJcuAqQJ90nnOsMXHwwK0VUq0wyVzgJDe50n2zRsk3ZXQGWSYtyvDX3uQZLjZgwMj6rB8QGVNcDQi66Tq5crCvIWlU7iPvsxDMJoAxh6E5C/ASTShqddJ1W3KkqB1qq0oMPoZjD8hh1zXSdOd6yX0IQqjp6svGXjaJBsdRve5TpZunv2lPIRMNE9YHjMgwTFXbbf7UxReYPhlRrpCw8SEzsz5KeVDwCW1zd5OJRRo1/scO1UjMrx6Iz7ZLAXZhunIyniPjt9dZ0A7Z3Rh07kAKTX3QfPPtphQH4bDD+vkR/ThbHrVXHfio6KYT9eHgQep8aQj2jkrzTSEypfPqetYkBYvl0j/ec8SJNSQ/rH1gXk8uUrWlcjv2eVzKa4Xb3mmP0Gt9Rj7KF/CoN+TyO/3/UCicZtCkK6s2kxAOnelIlxBAyvm/ff8LpkLHftV02jGVuw13ghRXGHTsVJnqktRjpESYT5qKGFZT/SQ6kSA5denCWTko4W2rXs/zbbAeosADlKc89IW09JPvZLoZFuTI0Y2Pi2he89JTD8SG3HZw+XMiVGKkRB/nsAxy9R1cR9Tss42zhMpXT4+rLK2Vxh7ErvxcDWd1d97ilgojvmHZ29gZRtMXwXJSk1mlufgOF3sjhMpW/4im5KHNTIX3spGnbuEMjHnmI3IystxrPSTuxMz/C+pyD9lazgNdIfXomB3Tse9a6n2Iupdi7s3JGKBWG0QXWZwNCjruNeYJvsLOuoB44kNrB4kdRx7OUc13HPG/JWW1Hyp3NHKgaGN3f3nl9SxPGKR/HvUoA87tqR6lZCB+y8/ESmDX1cL9X2b+r+O0gHnMdbbVN2lrXTA0eaa0nIpXqC2L9x7WfzjZEP2W/IB84dEUHiSg6O2q495DrBIgjP5WBa2SW76wSLIDyXg/3JWbots3ed5GYMsvoNMbRjdkaCvNW9MyLI/F1GMHSX6ySLIBzbQpMFV5Z5v+tE6x4fsqruxGvDoWuHdA8LAkg/VEdQ3LfCw5Vr3CuC2JPbRUHYshQPHIt7UJBpNTh+eo0wkgqU7R44GPeWIPTMkoHYLXCvDq1M5gWZVIZPqxNMeb3PlzwhQ4I0fEJaeSfXucM6w4IA0lsNibEgqNdcO60zKggY/n4ZF0WTqvhnXTuvMyaIPRRU4d5z1XLRyIM+XReDFAsCSLvVk3T+ssWYF2W4vMY+K+E6IJ1uQbarkd1nqrYxQmcnFywdz8AgbYLYi6nIz3XsxwAg5Fvs3osIwvUbj+HRIB9d2xEhaghzt33GT3oI1xCCuD+kB+xOuuo29n1bW9/UrTph8HXIslWgyNugwLd58468/bkJ+7C9/dYA0o+deBUC/BFkKnno0/BmO1r4/SbjQoqlU+1Uz+6TBSFf16rlGvhBlqRhtOH/Ot4GRkqXqqGxC9TQ5EndSZ4gCIIgCIIgCIIgCIIgCIIgCIIgCIIgCJb/AX4RWhfolytoAAAAAElFTkSuQmCC"
                                      />
                                    </defs>
                                  </svg>
                                </div>
                                <h4 class="browseFile__text">
                                  Change header Title
                                </h4>
                                <div className="header_title_input_container">
                                  <input
                                    type="text"
                                    className="header_adminform__input"
                                    placeholder="Enter the title"
                                    maxLength={20}
                                    value={headerTitle}
                                    onChange={(e) => {
                                      const inputValue = e.target.value;

                                      if (inputValue.length <= 20) {
                                        setHeaderTitle(inputValue);
                                      }
                                    }}
                                  />
                                </div>
                                <h4
                                  class="browseFile__text"
                                  style={{ marginTop: "10px" }}
                                >
                                  Change header Color
                                </h4>
                                <ColorDropdowns
                                  title={headerTitle}
                                  setHeaderTitleColor={setHeaderTitleColor}
                                />
                                <div></div>
                              </div>
                              <div class="adminbutton__group">
                                <button
                                  class="adminbtn adminbtn-primary"
                                  onClick={() =>
                                    cahngeHeaderTitleHandler(items?.id)
                                  }
                                >
                                  Save
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                  )}
                </div>
                {sectionData?.map(
                  (item) =>
                    item?.section_name === "Home Description" && (
                      <div className="commonList__row">
                        <h4 class="label">{item?.section_name}</h4>
                        <div className="cardbox">
                          <div class="adminform__group">
                            <textarea
                              class="adminform__textarea"
                              placeholder="write the contents here!"
                              value={homeDesc}
                              onChange={(e) => setHomeDesc(e.target.value)}
                            ></textarea>
                          </div>
                          <button
                            class="admibtn admibtn-primary"
                            onClick={() => dummyDescriptionHandler(item?.id)}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    )
                )}

                <div class="commonList__row">
                  <h4 class="label">{sectionData?.[1]?.section_name}:</h4>
                  <div class="cardbox">
                    <div class="adminform__group">
                      <textarea
                        class="adminform__textarea"
                        placeholder="write the contents here!"
                        value={homeDescription}
                        onChange={(e) => {
                          setHomeDescription(e.target.value);
                        }}
                      ></textarea>
                    </div>
                    <div class="adminbutton__group">
                      {/* <button class="admibtn admibtn-blueOutline">
                                    Cancel
                                  </button> */}
                      <button
                        class="admibtn admibtn-primary"
                        onClick={descriptionHandler}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CmsHome;
